import { useState } from 'react';
import './iframeViewer.css';

export default function IframeViewer({ url, title = 'Website Preview' }) {
  const [key] = useState(0);

  return (
    <div className="iframe-viewer-container">
      <div className="iframe-viewer-header">
        <h3>{title}</h3>
      </div>

      <div className="iframe-wrapper">
        <iframe
          key={key}
          src={url}
          title={title}
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
        ></iframe>
      </div>
    </div>
  );
}
